import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomeOne from "./HomeOne";
import HomeTwo from "./HomeTwo";
import HomeThree from "./HomeThree";
import HomeFour from "./HomeFour";
import About from "./About";
import LoadTop from "../Components/LoadTop";
import Destination from "./Destination";
import DestinationDetails from "./DestinationDetails";
import Service from "./Service";
import ServiceDetails from "./ServiceDetails";
import Activities from "./Activities";
import ActivitiesDetails from "./ActivitiesDetails";
import Shop from "./Shop";
import ShopDetails from "./ShopDetails";
import Cart from "./Cart";
import Checkout from "./Checkout";
import Wishlist from "./Wishlist";
import Gallery from "./Gallery";
import Tour from "./Tour";
import TourDetails from "./TourDetails";
import Resort from "./Resort";
import ResortDetails from "./ResortDetails";
import TourGuide from "./TourGuide";
import TourGuiderDetails from "./TourGuiderDetails";
import Faq from "./Faq";
import Pricing from "./Pricing";
import Error from "./Error";
import Blog from "./Blog";
import BlogDetails from "./BlogDetails";
import Contact from "./Contact";
import Login from "./Login";
import Register from "./Register";

import HomePrinter from "./HomePrinter";
import OfficePrinter from "./OfficePrinter";
import OurAcc from "./OurAcc";

import OrderConfirm from "./OrderConfirm";
import MyAccount from "./MyAccount";
import OrderTrack from "./OrderTrack";
import ReturnOrder from "./ReturnOrder";

import PrivacyPolicy from "./PrivacyPolicy";
import ReturnPolicy from "./ReturnPolicy";
import ShippingPolicy from "./ShippingPolicy";
import CookiePolicy from "./CookiePolicy";
import TermsConditions from "./TermsConditions";

function RouterPage() {
  return (
    <div>
      <Router>
        <LoadTop />
        <Routes>
          <Route path="/" element={<HomeOne />}></Route>
          <Route path="/home-tour" element={<HomeTwo />}></Route>
          <Route path="/home-agency" element={<HomeThree />}></Route>
          <Route path="/home-yacht" element={<HomeFour />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/destination" element={<Destination />}></Route>
          <Route path="/destination/:id" element={<DestinationDetails />} />
          <Route path="/service" element={<Service />}></Route>
          <Route path="/service/:id" element={<ServiceDetails />} />
          <Route path="/activities" element={<Activities />}></Route>
          <Route
            path="/activities-details"
            element={<ActivitiesDetails />}
          ></Route>
          <Route path="/shop" element={<Shop />}></Route>
          <Route path="/product-details/:id" element={<ShopDetails />}></Route>
          <Route path="/cart" element={<Cart />}></Route>
          <Route path="/checkout" element={<Checkout />}></Route>
          <Route path="/wishlist" element={<Wishlist />}></Route>
          <Route path="/gallery" element={<Gallery />}></Route>
          <Route path="/tour" element={<Tour />}></Route>
          <Route path="/tour-details" element={<TourDetails />}></Route>
          <Route path="/resort" element={<Resort />}></Route>
          <Route path="/resort/:id" element={<ResortDetails />}></Route>
          <Route path="/tour-guide" element={<TourGuide />}></Route>
          <Route path="/tour-guide/:id" element={<TourGuiderDetails />}></Route>
          <Route path="/faq" element={<Faq />}></Route>
          <Route path="/price" element={<Pricing />}></Route>
          <Route path="/error" element={<Error />}></Route>
          <Route path="/blog" element={<Blog />}></Route>
          <Route path="/blog/:id" element={<BlogDetails />}></Route>
          <Route path="/contact" element={<Contact />}></Route>
          <Route path="/login-now" element={<Login />}></Route>
          <Route path="/register-now" element={<Register />}></Route>

          <Route path="/home-printers" element={<HomePrinter />}></Route>
          <Route path="/office-printers" element={<OfficePrinter />}></Route>
          <Route path="/our-accessories" element={<OurAcc />}></Route>
          <Route path="/order-success" element={<OrderConfirm />}></Route>

          <Route path="/my-account" element={<MyAccount />}></Route>

          <Route path="/track-order" element={<OrderTrack />}></Route>
          <Route path="/return-order" element={<ReturnOrder />}></Route>

          <Route path="/return-order" element={<ReturnOrder />}></Route>

          <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
          <Route path="/return-policy" element={<ReturnPolicy />}></Route>
          <Route path="/shipping-policy" element={<ShippingPolicy />}></Route>
          <Route path="/cookie-policy" element={<CookiePolicy />}></Route>
          <Route
            path="/terms-and-conditions"
            element={<TermsConditions />}
          ></Route>
        </Routes>
      </Router>
    </div>
  );
}

export default RouterPage;
